import React, { useEffect } from "react";
import "./redesign.css";
import RedesignNav from "./layout/RedesignNav";
import RedesignFooter from "./layout/RedesignFooter";

const RedesignShell = ({ children }) => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="tt-page">
      <RedesignNav />
      <main style={{ paddingTop: 0 }}>
        {children}
      </main>
      <RedesignFooter />
    </div>
  );
};

export default RedesignShell;
